

import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import Modal from "react-modal";
import { useMediaQuery } from "@mui/material";

Modal.setAppElement("#root");

// ⭐ IMAGE CARD
const ImageCard = ({ combo, addToCart, quantities }) => {
  const [hovered, setHovered] = useState(false);
  const quantity = quantities[combo.dishId] || 0;
  const isMobile = useMediaQuery("(max-width: 768px)");

  const finalPrice = combo.effectivePrice || combo.price;
  const hasDiscount = combo.discount > 0;

  return (
    <div
      onMouseEnter={() => !isMobile && setHovered(true)}
      onMouseLeave={() => !isMobile && setHovered(false)}
      style={{ 
        padding: isMobile ? 8 : 10, 
        display: "flex", 
        justifyContent: "center",
        marginBottom: isMobile ? 16 : 0
      }}
    >
      <div
        style={{
          height: "auto",
          width: "100%",
          maxWidth: isMobile ? 340 : 360,
          borderRadius: 16,
          overflow: "hidden",
          position: "relative",
          background: "#000",
          transform: hovered ? "scale(1.03)" : "scale(1)",
          transition: "0.3s",
          boxShadow: isMobile ? "0 4px 8px rgba(0,0,0,0.1)" : "none",
        }}
      >
        {/* IMAGE */}
        <img
          src={combo.dishImage}
          alt={combo.dishName}
          style={{
            width: "100%",
            height: isMobile ? 220 : 260,
            objectFit: "cover",
            position: "absolute",
            zIndex: 1,
          }}
        />

        {/* OVERLAY */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 2,
          }}
        />

        {/* DISCOUNT BADGE */}
        {hasDiscount && (
          <div
            style={{
              position: "absolute",
              top: 10,
              left: 10,
              background: "red",
              padding: isMobile ? "4px 12px" : "6px 14px",
              borderRadius: 20,
              color: "#fff",
              fontWeight: 700,
              zIndex: 5,
              fontSize: isMobile ? 12 : 14,
            }}
          >
            🔥 {combo.discount}% OFF
          </div>
        )}

        {/* CONTENT */}
        <div
          style={{
            position: "relative",
            zIndex: 3,
            padding: isMobile ? 12 : 16,
            paddingTop: isMobile ? 230 : 270,
            color: "#fff",
          }}
        >
          <h3 style={{ 
            fontSize: isMobile ? 18 : 20, 
            fontWeight: 700,
            marginBottom: isMobile ? 8 : 12
          }}>
            {combo.dishName}
          </h3>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: isMobile ? 8 : 10,
            }}
          >
            <div style={{ 
              background: "green", 
              color: "#fff", 
              padding: isMobile ? "6px 12px" : "7px 14px", 
              borderRadius: 6,
              fontSize: isMobile ? 14 : 16,
              fontWeight: "bold"
            }}>
              ₹{finalPrice}
            </div>

            {hasDiscount && (
              <span style={{ 
                textDecoration: "line-through", 
                opacity: 0.6,
                fontSize: isMobile ? 14 : 16
              }}>
                ₹{combo.price}
              </span>
            )}

            {quantity === 0 ? (
              <button
                onClick={() => addToCart(combo, 1)}
                style={{
                  background: "rgb(177 92 214)",
                  padding: isMobile ? "6px 12px" : "8px 14px",
                  color: "#fff",
                  borderRadius: 6,
                  fontWeight: "bold",
                  border: "none",
                  fontSize: isMobile ? 12 : 14,
                  cursor: "pointer",
                }}
              >
                Add to Cart
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

// ⭐ MOBILE CARDS GRID COMPONENT
const MobileCardsGrid = ({ combosData, addToCart, quantities }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      
        gap: 8,
        padding: "0 10px",
      }}
    >
      {combosData.map((combo) => (
        <ImageCard
          key={combo.dishId}
          combo={combo}
          addToCart={addToCart}
          quantities={quantities}
        />
      ))}
    </div>
  );
};

// ⭐ MAIN COMPONENT
export default function Combos() {
  const navigate = useNavigate();
  const [combosData, setCombosData] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Media queries for responsive behavior
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 1024px)");

  // Fetch Data
  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId");
    const token = localStorage.getItem("authToken");

    if (!vendorId || !token) return;

    axios
      .get(
        ` https://backend.maamaas.com/food/api/dish/discount`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        const filtered = res.data.filter((x) => x.parentId !== 0);
        setCombosData(filtered);
      })
      .catch((err) => console.log(err));
  }, []);

  // ⭐ ADD TO CART
  const addToCart = async (item, qty) => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId) return alert("Please login first.");

    try {
      await axios.post(
        ` https://backend.maamaas.com/food/api/cart/add/${userId}`,
        { dishId: item.dishId, quantity: qty, orderType: "DINE_IN" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setQuantities((prev) => ({
        ...prev,
        [item.dishId]: qty,
      }));

      setCartItems((prev) => [...prev, { ...item, quantity: qty }]);
      setIsModalOpen(true);
    } catch (e) {
      alert("Error adding to cart");
    }
  };

  // Add this useEffect hook in your component
useEffect(() => {
  let autoCloseTimer;
  
  if (isModalOpen) {
    // Auto close modal after 2 seconds
    autoCloseTimer = setTimeout(() => {
      setIsModalOpen(false);
    }, 2000);
  }

  // Cleanup timer on component unmount or when modal closes
  return () => {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
    }
  };
}, [isModalOpen]);

  // ⭐ Navigate to Cart
  const handleViewCartClick = () => navigate("/cartsdata");

  // Slider Settings - Only for desktop/tablet
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2200,
    slidesToShow: 3,
    responsive: [
      { 
        breakpoint: 1024, 
        settings: { 
          slidesToShow: 2,
          dots: false
        } 
      },
      { 
        breakpoint: 900, 
        settings: { 
          slidesToShow: 2,
          dots: false
        } 
      },
      { 
        breakpoint: 768, 
        settings: "unslick" // This will disable slider below 768px
      },
    ],
  };

  return (
    <section style={{ 
      maxWidth: 999, 
      margin: "0 auto", 
      padding: isMobile ? "0 10px" : "0 20px",
      marginTop: isMobile ? 10 : 20
    }}>
      <h1 style={{ 
        textAlign: "center", 
        fontSize: isMobile ? 28 : 34, 
        fontWeight: 800,
        marginBottom: isMobile ? 20 : 30
      }}> <span style={{ color: "rgb(42 9 71)" }}></span>
        <span style={{ color: "red" }}>Flat</span>
         Offers
      </h1>

      {/* Conditional rendering based on screen size */}
      {isMobile ? (
        <MobileCardsGrid 
          combosData={combosData} 
          addToCart={addToCart} 
          quantities={quantities} 
        />
      ) : (
        <Slider {...settings}>
          {combosData.map((combo) => (
            <ImageCard
              key={combo.dishId}
              combo={combo}
              quantities={quantities}
              addToCart={addToCart}
            />
          ))}
        </Slider>
      )}

      {/* ⭐ STICKY BOTTOM MODAL - Responsive */}
      <Modal
  isOpen={isModalOpen}
  shouldCloseOnOverlayClick={false}
  style={{
    overlay: { 
      backgroundColor: "transparent", 
      pointerEvents: "none",
      zIndex: 1000 
    },
    content: {
      pointerEvents: "auto",
      position: "fixed",
      bottom: isMobile ? 20 : "auto",
      top: isMobile ? "auto" : "92%",
      left: "50%",
      transform: "translate(-50%, 0)",
      width: isMobile ? "95%" : "90%",
      maxWidth: isMobile ? 400 : 500,
      padding: 0,
      borderRadius: 12,
      border: "none",
      height: isMobile ? 70 : 77,
      marginTop: isMobile ? 0 : -40,
      boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    },
  }}
>
  {cartItems.length > 0 && (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: isMobile ? "12px 16px" : "14px 20px",
        background: "#fff",
        borderRadius: 12,
        border: "2px solid #ee6521",
        height: "100%",
      }}
    >
      <FaShoppingCart style={{ 
        fontSize: isMobile ? 24 : 28, 
        color: "#ee6521" 
      }} />

      <div style={{ 
        fontWeight: "bold", 
        fontSize: isMobile ? 16 : 18 
      }}>
        ({Object.values(quantities).reduce((a, b) => a + b, 0)}) Items
      </div>

      {/* Quantity Control */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? 8 : 10,
          background: "#f8f8f8",
          padding: isMobile ? "4px 8px" : "6px 10px",
          borderRadius: 8,
        }}
      >
        <button
          onClick={() => {
            const item = cartItems[cartItems.length - 1];
            const newQty = Math.max(1, (quantities[item.dishId] || 1) - 1);
            addToCart(item, newQty);
          }}
          style={{
            padding: isMobile ? "2px 6px" : "4px 8px",
            background: "red",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: 6,
            border: "none",
            fontSize: isMobile ? 14 : 16,
            cursor: "pointer",
            minWidth: isMobile ? 24 : 28,
          }}
        >
          –
        </button>

        <span style={{ 
          fontWeight: "bold",
          fontSize: isMobile ? 14 : 16,
          minWidth: isMobile ? 20 : 24,
          textAlign: "center"
        }}>
          {quantities[cartItems[cartItems.length - 1].dishId] || 1}
        </span>

        <button
          onClick={() => {
            const item = cartItems[cartItems.length - 1];
            const newQty = (quantities[item.dishId] || 1) + 1;
            addToCart(item, newQty);
          }}
          style={{
            padding: isMobile ? "2px 6px" : "4px 8px",
            background: "green",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: 6,
            border: "none",
            fontSize: isMobile ? 14 : 16,
            cursor: "pointer",
            minWidth: isMobile ? 24 : 28,
          }}
        >
          +
        </button>
      </div>

      <button
        onClick={handleViewCartClick}
        style={{
          padding: isMobile ? "6px 14px" : "8px 16px",
          background: "#ee6521",
          color: "#fff",
          borderRadius: 50,
          border: "none",
          fontSize: isMobile ? 12 : 14,
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        View Cart
      </button>
    </div>
  )}
</Modal>
    </section>
  );
}